import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "survey-quiz-questions-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_quiz_checkable_text_question = _resolveComponent("quiz-checkable-text-question");
  const _component_quiz_simple_text_question = _resolveComponent("quiz-simple-text-question");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.quizQuestionsExist ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.quiz.questions, question => {
    return _openBlock(), _createElementBlock(_Fragment, null, [_ctx.isCheckableQuestion(question) ? (_openBlock(), _createBlock(_component_quiz_checkable_text_question, {
      key: 0,
      class: "survey-quiz-question",
      question: question,
      "question-custom-label": _ctx.getQuestionLabel(question),
      selected: _ctx.userAnswers(question),
      "is-result-mode": _ctx.isResultMode,
      onSelectionChange: val => _ctx.onSelectionChange(question.id, val)
    }, null, 8, ["question", "question-custom-label", "selected", "is-result-mode", "onSelectionChange"])) : _createCommentVNode("", true), _ctx.isTextQuestion(question) ? (_openBlock(), _createBlock(_component_quiz_simple_text_question, {
      key: 1,
      class: "survey-quiz-question",
      question: question,
      "question-custom-label": _ctx.getQuestionLabel(question),
      answer: _ctx.userAnswers(question),
      "answer-label": _ctx.isResultMode ? _ctx.$t('view.speach.surveyQuiz.answerLabel') : _ctx.$t('view.speach.surveyQuiz.answerInputLabel'),
      "input-type": _ctx.getQuestionTextType(question),
      "is-result-mode": _ctx.isResultMode,
      onAnswerChange: val => _ctx.onTextAnswerChange(question.id, val)
    }, null, 8, ["question", "question-custom-label", "answer", "answer-label", "input-type", "is-result-mode", "onAnswerChange"])) : _createCommentVNode("", true)], 64);
  }), 256)) : _createCommentVNode("", true)]);
}